import { Typography } from "@mui/material";
import { KVCardRow } from "./CardContent";

export default function PromptCardContent({ node }) {
  const parameters = node.data.parameters.map((param) => {
    return (
      <Typography variant="body2" color={"#b5b5b5"}>
        {param}
      </Typography>
    );
  });

  return (
    <div>
      <KVCardRow
        label="Custom Name"
        value={node.data.advanced.customName}
      ></KVCardRow>
      <KVCardRow
        label="Description"
        value={node.data.advanced.description}
      ></KVCardRow>
      <KVCardRow
        label="Message"
        value={
          <pre>
            <code>{node.data.message}</code>
          </pre>
        }
      ></KVCardRow>
      <KVCardRow label="Parameters" value={parameters}></KVCardRow>
    </div>
  );
}
